import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';

import { Role } from '../../models/api-response.model';
import { RoleManagementService } from '../../services/role_management_service';

@Component({
  selector: 'app-role-management',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './role-management.component.html',
  styleUrls: ['./role-management.component.scss']
})
export class RoleManagementComponent implements OnInit {
  private readonly fb = inject(FormBuilder);
  private readonly service = inject(RoleManagementService);
  roles: Role[] = [];
  currentPage = 1;
  readonly pageSize = 8;
  readonly form = this.fb.nonNullable.group({
    name: ['', [Validators.required, Validators.minLength(2)]],
    description: ['']
  });

  ngOnInit(): void {
    this.load();
  }

  create(): void {
    if (this.form.invalid) {
      return;
    }
    this.service.create(this.form.getRawValue()).subscribe(() => {
      this.form.reset();
      this.load();
    });
  }

  private load(): void {
    this.service.list().subscribe((response) => {
      this.roles = response.value === '' ? [] : response.value;
      this.currentPage = 1;
    });
  }

  get totalPages(): number {
    return Math.max(1, Math.ceil(this.roles.length / this.pageSize));
  }

  get paginatedRoles(): Role[] {
    const start = (this.currentPage - 1) * this.pageSize;
    return this.roles.slice(start, start + this.pageSize);
  }

  goToPage(page: number): void {
    this.currentPage = Math.min(Math.max(page, 1), this.totalPages);
  }
}
